import { render, staticRenderFns } from "./MenuItemBoxResult.vue?vue&type=template&id=43bf1d20&"
import script from "./MenuItemBoxResult.vue?vue&type=script&lang=js&"
export * from "./MenuItemBoxResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports